import React, { useContext, useEffect } from "react";
import { useContent } from "../content/ContentProvider";
import { RouteFadeContext } from "../App";

export default function Home() {
  const { fadeTo } = useContext(RouteFadeContext);
  const { hero } = useContent();
  const HERO_IMAGE = hero.image;
  const HERO_H1 = hero.h1;

  useEffect(() => {
    document.title = "Ruby Fos";
  }, []);

  const go = (e, path) => {
    e.preventDefault();
    fadeTo(path, 650);
  };

  return (
    <div
      className="page-enter"
      style={{
        position: "relative",
        height: "100vh",
        width: "100vw",
        overflow: "hidden",
        background: "#000",
      }}
    >
      {/* Full-bleed background image, no borders */}
      <img
        src={HERO_IMAGE}
        alt=""
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          filter: "brightness(0.95) contrast(1) saturate(1)",
        }}
      />
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(ellipse at center, rgba(0,0,0,0) 0%, rgba(0,0,0,0.18) 75%, rgba(0,0,0,0.35) 100%)",
        }}
      />

      {/* Ruby Fos \u2014 upper area, slightly toward centre */}
      <div
        style={{
          position: "absolute",
          left: "11vw",
          top: "26vh",
          color: "#f4ece0",
        }}
      >
        <h1
          className="font-math"
          style={{
            margin: 0,
            fontStyle: "italic",
            fontWeight: 500,
            fontSize: "clamp(1.05rem, 1.35vw, 1.35rem)",
            lineHeight: 1,
            letterSpacing: "0",
            textShadow: "0 2px 18px rgba(0,0,0,0.55)",
            whiteSpace: "nowrap",
          }}
        >
          {HERO_H1}
        </h1>
      </div>

      {/* Works \u00b7 Contact \u2014 same line, right of horizontal centre */}
      <nav
        style={{
          position: "absolute",
          left: "78vw",
          top: "50%",
          transform: "translateY(-50%)",
          display: "flex",
          flexDirection: "row",
          alignItems: "baseline",
          gap: "2.6rem",
          color: "#f4ece0",
        }}
      >
        <a
          href="/works"
          onClick={(e) => go(e, "/works")}
          className="font-math nav-link"
          style={navLinkStyle}
        >
          Works
        </a>
        <a
          href="/contact"
          onClick={(e) => go(e, "/contact")}
          className="font-math nav-link"
          style={navLinkStyle}
        >
          Contact
        </a>
      </nav>

      <style>{`
        .nav-link {
          position: relative;
          display: inline-block;
          width: max-content;
          transition: opacity 400ms ease, letter-spacing 400ms ease;
        }
        .nav-link::after {
          content: "";
          position: absolute;
          left: 0; right: 100%;
          bottom: -3px;
          height: 1px;
          background: rgba(244,236,224,0.85);
          transition: right 500ms ease;
        }
        .nav-link:hover { letter-spacing: 0.03em; }
        .nav-link:hover::after { right: 0; }
      `}</style>
    </div>
  );
}

// Same italic/size for Ruby Fos and the nav links.
const navLinkStyle = {
  fontStyle: "italic",
  fontWeight: 500,
  fontSize: "clamp(1.05rem, 1.35vw, 1.35rem)",
  color: "#f4ece0",
  textDecoration: "none",
  letterSpacing: "0",
  lineHeight: 1,
  textShadow: "0 2px 18px rgba(0,0,0,0.55)",
};
